<ng-container *vsLet="isLargeScreen$ | async as isLargeScreen">
  <ng-container *ngIf="policies$ | async as policies; else loadingPolicies">
    <ng-container *ngIf="policies.length; else noPlans">
      <!-- policy grid -->
      <div
        class="grid grid-cols-2 gap-3 max-h-[50vh] overflow-y-auto scrollbar-thin -m-1 p-1"
        [class.grid-cols-2]="policies.length > 1 && isLargeScreen"
      >
        <ws-policy-details-card
          *ngFor="let policy of policies"
          [policy]="policy"
          [staffView]="staffView"
          [selected]="policy.id === selected?.id"
          (clicked)="selectPolicy(policy)"
        ></ws-policy-details-card>
      </div>
    </ng-container>

    <ng-template #noPlans>
      <ws-no-plans-available-card
        [hideBack]="true"
        [propertySetName]="propertySet?.name || 'asset'"
      ></ws-no-plans-available-card>
    </ng-template>
  </ng-container>

  <ng-template #loadingPolicies>
    <div
      class="flex flex-col items-center justify-center gap-3 py-12 text-center text-gray-600"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <vs-icon aria-hidden="true" name="loading-01" class="animate-spin text-primary-500" size="36"></vs-icon>
      <p class="text-sm font-medium">Evaluating available policies...</p>
      <p class="text-xs text-gray-500">This can take a moment for complex eligibility rules.</p>
    </div>
  </ng-template>
</ng-container>
